export default __webpack_public_path__ + "static/listening-517e514e8a3591dace0251c02cb8e5d6.svg";